/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener("DOMContentLoaded", function () {
	const countDown = document.querySelectorAll(".wpopus-count-down-wrapper");

	if (!countDown) {
		return;
	}

	Array.from(countDown).forEach((values) => {
		const countDownDate = new Date(values.getAttribute('data-countDown')).getTime();
		if (!countDownDate) return;

		// Cache DOM elements
		const daysEl = values.querySelector(".days");
		const hoursEl = values.querySelector(".hours");
		const minutesEl = values.querySelector(".minutes");
		const secondsEl = values.querySelector(".seconds");
		const expiredEl = values.querySelector(".expired");
		const countDownEl = values.querySelector(".wpopus-count-down");

        console.log(expiredEl);

		if (!daysEl || !hoursEl || !minutesEl || !secondsEl || !expiredEl) return;

		const updateCountdown = () => {
			const now = Date.now();
			const distance = countDownDate - now;

			if (distance < 0) {
				expiredEl.textContent = "Expired";

				// Add/remove classes
				countDownEl.classList.add("is-expired");
				expiredEl.classList.add("is-visible");

				clearInterval(intervalId);
				return;
			} else {
				countDownEl.classList.remove("is-expired");
				expiredEl.classList.remove("is-visible");
			}

			// Calculate time units
			const days = Math.floor(distance / (1000 * 60 * 60 * 24));
			const hours = Math.floor(
				(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
			);
			const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			const seconds = Math.floor((distance % (1000 * 60)) / 1000);

			// Update DOM
			daysEl.textContent = days;
			hoursEl.textContent = hours.toString().padStart(2, "0");
			minutesEl.textContent = minutes.toString().padStart(2, "0");
			secondsEl.textContent = seconds.toString().padStart(2, "0");
		};

		const intervalId = setInterval(updateCountdown, 500);

		// Cleanup on unmount
		return () => clearInterval(intervalId);
	});
});
